import React, { useState } from "react";
import { Settings } from "lucide-react";

import Modal from "./Modal";
import Button from "@/components/button/Button";
import EquityWeightsModal from "./EquityWeightsModal";
import type { Role } from "@/types.ts";

export type EquityConfigModalProps = {
    open: boolean;
    onClose: () => void;
    roles: Role[];
};

const EquityConfigModal: React.FC<EquityConfigModalProps> = ({ open, onClose, roles }) => {
    const [weightsOpen, setWeightsOpen] = useState(false);

    return (
        <>
            <Modal
                open={open}
                onClose={onClose}
                title="Configurations d'équité"
                size="md"
                footer={
                    <button
                        onClick={onClose}
                        className="inline-flex items-center rounded-full bg-green-600 px-4 py-2 font-medium text-white cursor-pointer hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500"
                    >
                        Fermer
                    </button>
                }
            >
                <div
                    onClick={() => setWeightsOpen(true)}
                    className="px-4 py-0 border-1 border-gray-300 rounded-sm my-2 cursor-pointer"
                >
                    <div className="flex items-center gap-2 min-h-12">
                        <Settings/>
                        <span className="text-sm">Configurations des poids d'équité</span>
                        <div className="ml-auto">
                            <Button type="primary" icon={<Settings size={20}/>}/>
                        </div>
                    </div>
                </div>
            </Modal>

            <EquityWeightsModal
                open={weightsOpen}
                onClose={() => setWeightsOpen(false)}
                roles={roles}
            />
        </>
    );
};

export default EquityConfigModal;
